export const recipesFr = {
  title: 'Recettes et nomenclatures',
  subtitle: 'Formules versionnées, auditables et nomenclatures multiniveaux.',
  empty: 'Aucune version ne correspond aux filtres.',
  pagination: 'Page {{page}} sur {{pages}} · {{total}} versions',
  help: {
    open: 'Ouvrir l’aide des recettes et nomenclatures',
    list: 'Filtrer par cycle de vie, produit de sortie, composant ou validité.',
    header:
      'Le numéro et le produit de sortie identifient la recette stable. Le contenu évolue par versions contrôlées.',
    translations:
      'Les noms et descriptions sont conservés séparément pour chaque langue prise en charge.',
    components:
      'Les positions référencent des articles ou sous-recettes approuvées. Quantités et coûts utilisent des décimales exactes.',
    dmsSnapshot: 'Sélectionnez les originaux DMS protégés appartenant exactement à cette version.',
    history:
      'Les versions approuvées restent immuables et peuvent être copiées dans un nouveau brouillon.',
    impact:
      'Affiche les recettes parentes directes et tous les produits touchés dans toute la hiérarchie de nomenclature.',
    productUsage:
      'Sélectionnez un composant pour afficher chaque recette et produit qui l’utilise directement.',
  },
  actions: {
    new: 'Nouvelle recette / BOM',
    alternatives: 'Alternatives',
    submit: 'Soumettre au contrôle',
    review: 'Terminer le contrôle',
    approve: 'Approuver',
    copy: 'Copier la version',
    block: 'Bloquer',
    archive: 'Archiver',
    addComponent: 'Ajouter une position',
    compare: 'Comparer les versions',
    addAlternative: 'Ajouter une alternative',
    reject: 'Refuser',
  },
  filters: {
    search: 'Rechercher numéro, recette ou produit',
    status: 'Statut du cycle de vie',
    allStatuses: 'Tous les statuts',
    validOn: 'Valide le',
    componentSearch: 'Rechercher article, recette, position ou commentaire',
  },
  columns: {
    number: 'Numéro',
    name: 'Nom',
    output: 'Produit de sortie',
    version: 'Version',
    status: 'Statut',
    reference: 'Quantité de référence',
    components: 'Positions',
    cost: 'Coût matière',
    validity: 'Validité',
    updated: 'Dernière modification',
  },
  statuses: {
    DRAFT: 'Brouillon',
    IN_REVIEW: 'En contrôle',
    APPROVED: 'Approuvée',
    BLOCKED: 'Bloquée',
    ARCHIVED: 'Archivée',
  },
  componentTypes: {
    MATERIAL: 'Matière',
    SUB_RECIPE: 'Sous-recette',
    PACKAGING: 'Emballage',
    BY_PRODUCT: 'Sous-produit',
  },
  substitutionStatuses: {
    PROPOSED: 'Proposée',
    APPROVED: 'Approuvée',
    REJECTED: 'Refusée',
    ARCHIVED: 'Archivée',
  },
  editor: {
    newTitle: 'Créer une recette / BOM',
    newDescription: 'Créer l’identité stable et sa première version modifiable.',
    versionDescription: 'Version contrôlée v{{version}}',
    reorder: 'Réordonner la position',
  },
  fields: {
    number: 'Numéro recette / BOM',
    outputProduct: 'Produit de sortie',
    name: 'Nom',
    baseQuantity: 'Quantité de référence',
    baseUnit: 'Unité de base',
    validFrom: 'Valide à partir du',
    validTo: 'Valide jusqu’au',
    currency: 'Devise de coût',
    comments: 'Commentaires internes',
    localizedName: 'Nom localisé',
    description: 'Description',
    position: 'Position',
    type: 'Type de position',
    component: 'Composant',
    quantity: 'Quantité',
    unit: 'Unité',
    percentage: 'Part %',
    loss: 'Perte %',
    declarationRelevant: 'Pertinent pour la déclaration',
    alternatives: 'Alternatives',
    comment: 'Commentaire',
    selectSubRecipe: 'Choisir une sous-recette approuvée',
    selectProduct: 'Choisir un article',
    alternativeProduct: 'Article alternatif',
    alternativeRecipe: 'Sous-recette alternative',
    factor: 'Facteur de substitution',
    rationale: 'Justification technique',
    reason: 'Motif et note de décision',
  },
  sections: {
    header: 'En-tête de recette',
    translations: 'Langues',
    components: 'Composants et sous-recettes',
    snapshotDocuments: 'Instantané documentaire',
    history: 'Historique des versions',
    whereUsed: 'Recettes parentes et produits touchés',
    affectedProducts: 'Tous les produits touchés sur tous les niveaux de nomenclature',
    productUsage: 'Utilisation du composant sélectionné',
    documents: 'Dossier DMS de la recette',
  },
  summary: {
    quantities: 'Totaux par unité',
    percentage: 'Total des parts saisies',
    cost: 'Coût matière calculé',
  },
  warnings: {
    UNIT_NOT_SUMMABLE:
      'La position {{position}} ne peut pas être convertie dans l’unité de base {{unit}}.',
    COMPONENT_ARCHIVED: 'L’article de la position {{position}} est archivé.',
    SUB_RECIPE_NOT_APPROVED: 'La sous-recette de la position {{position}} n’est pas approuvée.',
    PERCENTAGE_TOTAL_NOT_100: 'Les parts saisies totalisent {{percentage}} % au lieu de 100 %.',
    INPUT_OUTPUT_DEVIATION:
      'Les entrées convertibles ({{input}} {{unit}}) diffèrent de la sortie de référence ({{output}} {{unit}}).',
  },
  states: {
    invalidDecimal: 'Décimale invalide',
    noDocuments: 'Aucun document de recette protégé.',
    notUsed: 'Aucune utilisation trouvée.',
  },
  messages: {
    saved: 'Version de recette enregistrée.',
    invalid: 'Corrigez les données de recette invalides.',
    submitted: 'Recette soumise à un contrôle indépendant.',
    workflowUpdated: 'Workflow de recette mis à jour.',
  },
  tabs: {
    editor: 'Éditeur',
    history: 'Versions et comparaison',
    impact: 'Utilisation / impact',
    processRouting: 'Gamme de fabrication',
    documents: 'Documents DMS',
  },
  alternatives: {
    title: 'Composants alternatifs et substitutions approuvées',
    empty: 'Aucune alternative définie pour cette position.',
  },
  actionDialog: {
    REVIEW: {
      title: 'Terminer le contrôle technique',
      description: 'Confirmez le contrôle indépendant par une note traçable.',
    },
    APPROVE: {
      title: 'Approuver la version',
      description: 'L’approbation fige cette version et applique le principe des quatre yeux.',
    },
    COPY: {
      title: 'Copier dans une nouvelle version',
      description: 'Un brouillon modifiable est créé et les substitutions sont réévaluées.',
    },
    BLOCK: {
      title: 'Bloquer la version',
      description: 'La version reste immuable mais ne peut plus être utilisée.',
    },
    ARCHIVE: {
      title: 'Archiver la version',
      description: 'La version reste traçable et sort de l’utilisation active.',
    },
    SUB_APPROVE: {
      title: 'Approuver la substitution',
      description: 'Confirmez indépendamment l’équivalence technique et sa preuve.',
    },
    SUB_REJECT: {
      title: 'Refuser la substitution',
      description: 'Documentez pourquoi l’alternative ne doit pas être utilisée.',
    },
  },
  compare: {
    title: 'Comparer les versions',
    description: 'Les différences proviennent des instantanés immuables.',
    headerChanges: 'Modifications d’en-tête',
    none: 'Aucune modification.',
    added: 'Positions ajoutées',
    removed: 'Positions supprimées',
    changed: 'Positions modifiées',
  },
  compareFields: {
    name: 'Nom',
    baseQuantity: 'Quantité de référence',
    baseUnitCode: 'Unité de base',
    validFrom: 'Valide à partir du',
    validTo: 'Valide jusqu’au',
    comments: 'Commentaires',
    dmsAttachmentIds: 'Instantané documentaire DMS',
    costCurrency: 'Devise de coût',
    internalMaterialCost: 'Coût matière',
    translations: 'Traductions',
  },
} as const;
